import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState: IAppState = {
  headerConfig: {
    title: '',
    subtitle: '',
    hasBackArrow: false,
    backArrowTo: null,
    helmetTitle: ''
  },
  isLoading: 0,
  dealerGroup: null,
  productType: null,
  leasingCompanyId: null,
  wsIsConnected: false,
  shouldUpdateLeasing: false
};

export type TAppState = typeof initialState;

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setHeaderConfig: (
      state,
      action: PayloadAction<Partial<IAppState['headerConfig']>>
    ) => {
      state.headerConfig = {
        ...initialState.headerConfig,
        ...action.payload
      };
    },
    startLoading: (state) => {
      state.isLoading++;
    },
    stopLoading: (state) => {
      state.isLoading--;
      if (state.isLoading < 0) {
        state.isLoading = 0;
      }
    },
    resetLoading: (state) => {
      state.isLoading = 0;
    },
    setDealerGroup: (
      state,
      action: PayloadAction<IAppState['dealerGroup']>
    ) => {
      state.dealerGroup = action.payload;
    },
    setProductType: (state, action: PayloadAction<string | null>) => {
      const product = action.payload;
      state.productType =
        product === 'leasing' ? 'leasing' : product ? 'autocredit' : null;
    },
    setLeasingCompanyId: (state, action: PayloadAction<string | null>) => {
      state.leasingCompanyId = action.payload;
    },
    setWsIsConnected: (state, action: PayloadAction<boolean>) => {
      state.wsIsConnected = action.payload;
    },
    setShouldUpdateLeasing: (state, action: PayloadAction<boolean>) => {
      state.shouldUpdateLeasing = action.payload;
    }
  }
});

export const {
  setHeaderConfig,
  startLoading,
  stopLoading,
  resetLoading,
  setDealerGroup,
  setProductType,
  setLeasingCompanyId,
  setWsIsConnected,
  setShouldUpdateLeasing
} = appSlice.actions;

export default appSlice;

interface IAppState {
  headerConfig: {
    title: string;
    subtitle: string;
    hasBackArrow: boolean;
    backArrowTo: string | -1 | null;
    helmetTitle: string;
  };
  isLoading: number;
  dealerGroup: {
    uuid: string;
    name: string;
    logo_url: string;
  } | null;
  productType: 'autocredit' | 'leasing' | null;
  leasingCompanyId: string | null;
  wsIsConnected: boolean;
  shouldUpdateLeasing: boolean;
}
